const featherIcons = require('feather-icons')

document.addEventListener('turbolinks:load', () => {
  featherIcons.replace()
})
